<template>
  <vue-pull-refresh
    :on-refresh="onRefresh"
    :config="pullConfig"
  >
    <div
      layout="row"
      flex
    >
      <div
        layout="column"
        class="messages-col"
        layout-align="start start"
        flex
      >
        <!-- Circle info if not my circle -->
        <div
          layout="row"
          class="px1-mobile pb1-mobile pa2-pc mb-2 full-width"
          layout-align="start center"
          style="background: white"
          v-if="(isCircleShow && displayedCircle) || circle"
        >
          <div layout="column">
            <div
              layout="row"
              class="headline"
            >{{ circle ? $t('nav.circle') : displayedCircle.name}}
              <v-icon
                v-if="circle"
                class="ml-2"
              >star</v-icon>
            </div>
            <div
              layout="row"
              class="subheading"
            >{{circle ? circleInfo : displayedCircle.description}}</div>
          </div>
          <template v-if="!circle">
            <span flex></span>
            <div>
              <v-btn
                v-if="canJoin"
                @click="joinCircle"
                color="secondary"
                class="ma-0"
              >{{$t('circles.join')}}</v-btn>
              <!-- Button to quit the circle -->
              <v-btn
                v-if="canLeave"
                @click="leaveCircle"
                color="error"
                class="ma-0"
                depressed
              >{{$t('circles.leave')}}</v-btn>
              <v-btn
                v-if="isOwnCircle"
                icon
                class="ma-0"
                :title="$t('circles.edit')"
                :to="{name: 'circles-edit', params: {id: displayedCircle.id}}"
              >
                <v-icon color="secondary">mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="circleDeletable"
                icon
                class="ma-0"
                :title="$t('circles.delete_dialog')"
                @click="deleteDialog = true"
              >
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
        <!-- Circle info div-->
        <!--<div
          v-if="circle && circle_info && !isCircleShow"
          layout="row"
          layout-align="start center"
          class="full-width mb-1 pa-2"
          style="background: lightcyan"
        >
          <span class="secondary--text">{{circleInfo}}</span>
          <span flex></span>
          <a
            @click.prevent="hideCircleInfo"
            href="#"
            class="black--text"
          >{{$t('messages.understood')}}</a>
        </div>-->
        <!-- New messages header -->
        <div
          v-if="!isCircleShow || !canJoin"
          layout="row"
          class="px1-mobile pb1-mobile pa2-pc full-width"
          layout-align="start center"
        >
          <span
            @click.prevent="newMessage"
            class="subheading clickable"
            :class="{'active-form' : isEditingMessage}"
          >{{$t('messages.new')}}</span>
          <span
            v-if="!circle && !isCircleShow"
            class="grey--text ml-2 mr-2"
          >|</span>
          <span
            v-if="!circle && !isCircleShow"
            @click.prevent="newEvent"
            class="subheading clickable"
            :class="{'active-form' : isEditingEvent}"
          >{{$t('messages.new_evt')}}</span>
          <span flex></span>

          <v-btn
            @click="displayFilters = !displayFilters"
            icon
            class="hidden-md-and-up ma-0"
          >
            <i
              :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']"
              style="color: black"
            ></i>
          </v-btn>
        </div>

        <div
          v-if="$vuetify.breakpoint.smAndDown && displayFilters"
          layout="column"
          layout-align="start start"
          class="full-width bg-white mt-2 pa-2"
        >
          <div
            layout="row"
            layout-align="start center"
            class="title grey--text text-uppercase font-weight-medium mb1-mobile mt-1"
          >{{$t('messages.filter')}}</div>
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            single-line
            flat
            v-model="filters.keywords"
            @keyup.enter="fetch(true)"
            hide-details
            class="full-width"
            :label="$t('filters.schools_hint')"
          ></v-text-field>

          <v-expansion-panel class="mt-3 exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div>{{$t('messages.msg_types')}}</div>
              </template>
              <v-checkbox
                v-for="t in types"
                hide-details
                :label="t.text"
                :value="t.value"
                v-model="filters.type"
                :key="`typefilter_${t.value}`"
                @change="fetch(true)"
                class="mt-0 pt-0 text-lowercase filter-cb"
                :disabled="circle || isCircleShow"
              >
                <template slot="label">
                  <div
                    layout="row"
                    layout-align="start center"
                  >
                    <v-icon class="mr-2">mdi-{{t.icon}}</v-icon>
                    <span class="body-1">{{t.text}}</span>
                  </div>
                </template>
              </v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div>{{$t('_.date')}}</div>
              </template>
              <div
                layout="row"
                layout-align="start center"
                flex
              >
                <div
                  layout="column"
                  layout-align="start start"
                  class="mr-2"
                  flex
                >
                  {{$t('_.from')}}
                  <v-menu
                    ref="menu3"
                    :close-on-content-click="false"
                    v-model="startDatepicker2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    class="full-width"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="startFormatted"
                      :label="$t('_.date_format')"
                      single-line
                      flat
                      outline
                      append-outer-icon="mdi-calendar"
                      @blur="onStartBlur"
                      @keyup.enter="onStartBlur"
                    />
                    <v-date-picker
                      v-model="filters.start"
                      no-title
                      @input="startDatepicker2 = false; filters.start = parseDate(filters.start)"
                      @change="fetch(true)"
                      :first-day-of-week="1"
                      :locale="_locale"
                    />
                  </v-menu>
                </div>
                <div
                  layout="column"
                  layout-align="start start"
                  flex
                >
                  {{$t('_.to')}}
                  <v-menu
                    ref="menu4"
                    :close-on-content-click="false"
                    v-model="endDatepicker2"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    offset-x
                    bottom
                    left
                    full-width
                    class="full-width"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="endFormatted"
                      :label="$t('_.date_format')"
                      single-line
                      flat
                      outline
                      append-outer-icon="mdi-calendar"
                      @blur="onEndBlur"
                      @keyup.enter="onEndBlur"
                    />
                    <v-date-picker
                      v-model="filters.end"
                      no-title
                      @input="endDatepicker2 = false; filters.end = parseDate(filters.end)"
                      :first-day-of-week="1"
                      @change="fetch(true)"
                      :locale="_locale"
                    />
                  </v-menu>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div>{{$t('filters.sender_sectors')}}</div>
              </template>
              <v-checkbox
                v-for="s in sectors"
                hide-details
                :label="s.text"
                :value="s.value"
                v-model="filters.sector"
                :key="`sectorfilter_${s.value}`"
                @change="fetch(true)"
                class="mt-0 pt-0 filter-cb"
              ></v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div>{{$t('filters.sender_lvs')}}</div>
              </template>
              <v-checkbox
                v-for="l in levels"
                hide-details
                :label="l.text"
                :value="l.value"
                v-model="filters.level"
                :key="`levelfilter_${l.value}`"
                @change="fetch(true)"
                class="mt-0 pt-0 filter-cb"
              ></v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div>{{$t('nav.circles')}}</div>
              </template>
              <v-checkbox
                v-for="c in $store.state.circles"
                hide-details
                :label="c.name"
                :value="c.id"
                v-model="filters.circle_id"
                :key="`circlefilter_${c.id}`"
                @change="fetch(true)"
                class="mt-0 pt-0 filter-cb"
                :disabled="circle || isCircleShow"
              ></v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
        <div
          v-if="!isCircleShow || !canJoin"
          id="message-form"
          layout="column"
          layout-align="start start"
          class="full-width px2-pc py3-pc pa1-mobile mt10-pc mt2-mobile bg-white"
        >
          <div
            v-if="!isEditingMessage && !isEditingEvent"
            @click="newMessage"
            layout="row"
            layout-align="start center"
            class="grey--text full-width pl-3 clickable"
            style="height: 40px"
          >{{$t('messages.new_placeholder')}}</div>
          <message-form
            v-if="isEditingMessage"
            @cancel="onMessageCancel"
            @save="save"
            ref="messageForm"
            v-model="editingMessage"
            :loading="loading"
          ></message-form>
          <message-form
            v-if="isEditingEvent"
            is-event
            @cancel="onEventCancel"
            @save="save"
            ref="messageForm"
            v-model="editingMessage"
            :loading="loading"
          ></message-form>
        </div>
        <div
          layout="row"
          layout-align="center center"
          class="full-width"
        >
          <v-btn
            @click="loadNewMessages"
            v-if="hasNewMessage"
            color="secondary"
            style="position :fixed; text-transform: none; z-index: 250"
            :style="(yPosition > 110) ? 'top: 10px' : 'top: 110px'"
            round
            depressed
          >
            <v-icon>mdi-arrow-up</v-icon>
            {{$t('messages.news')}}
          </v-btn>
        </div>
        <div
          v-for="(m,i) in messages"
          :key="m.id"
          class="full-width"
        >
          <div
            v-if="limit && i == limit"
            layout="row"
            layout-align="start center"
            class="full-width"
            style="margin-top: 10px"
          >
            <v-divider></v-divider>
            <span class="font-weight-bold mx-2">{{$t('messages.up_to_date')}}</span>
            <v-divider></v-divider>
          </div>
          <message
            :message="m"
            class="full-width"
            style="margin-top: 10px"
            @edit="editMessage(m)"
            @removed="onDelete(i)"
            @deleted="onDelete(i)"
            @updated="onMessageUpdate"
          ></message>
        </div>
        <div
          v-if="loading && !noMoreData"
          layout="row"
          layout-align="center center"
          class="mt-3 full-width font-weight-black"
          style="color: #616161"
        >{{$t('messages.loading')}}</div>
        <div
          v-if="loading && !noMoreData"
          layout="row"
          layout-align="center center"
          class="mt-2 full-width"
        >
          <beat-loader
            :loading="loading && !noMoreData"
            color="grey"
          ></beat-loader>
        </div>

        <div
          v-if="!loading && noMoreData && !messages.length"
          layout="row"
          layout-align="center center"
          class="mt-3 full-width font-weight-black"
          style="color: #616161"
        >{{$t('messages.no_message')}}</div>
      </div>
      <div
        layout="column"
        layout-align="start start"
        class="hidden-sm-and-down"
        style="width: 300px"
      >
        <div
          layout="column"
          layout-align="start start"
          class="full-width px2-pc mb10-pc pb-4 mb1-mobile px1-mobile bg-white"
        >
          <div
            layout="row"
            layout-align="start center"
            class="title grey--text text-uppercase font-weight-medium mb-4 mb1-mobile mt3-pc"
          >{{$t('messages.last_photos')}}</div>
          <div
            layout="row"
            layout-align="center center"
            class="full-width"
          >
            <img
              @click="onPhotoClick(p)"
              v-for="(p,i) in photos"
              :key="'lp_'+p.id"
              :src="getImageData(p.id + '-preview') || getImageData(p.id)"
              class="clickable"
              style="max-width: 90px; max-height: 90px;"
              :style="i == 0 ? 'margin-left: 2px' : 'margin-left: 5px'"
            />
            <span
              v-if="!photos || !photos.length"
              class="full-width text-xs-center mt-4 mb-5"
            >{{ $t('messages.no_photo') }}</span>
          </div>
        </div>
        <div
          layout="column"
          layout-align="start start"
          class="full-width px2-pc mb10-pc pb-4 mb1-mobile px1-mobile bg-white"
        >
          <div
            layout="row"
            layout-align="start center"
            class="title grey--text text-uppercase font-weight-medium mb-3 mb1-mobile mt3-pc"
          >{{$t('messages.last_docs')}}</div>
          <div
            v-for="d in docs"
            @click="downloadDoc(d)"
            layout="row"
            layout-align="start center"
            class="full-width mb-1 clickable primary--text"
            :key="'ld_'+d.id"
          >
            <v-icon
              color="primary"
              class="ml-0 mr-1"
            >mdi-paperclip</v-icon>
            <span class="break-word">{{d.document.name}}</span>
          </div>
          <div
            v-if="!docs || !docs.length"
            layout="row"
            layout-align="start center"
            class="full-width"
          >
            <span class="full-width text-xs-center mt-4 mb-5">{{ $t('messages.no_doc') }}</span>
          </div>
        </div>
        <div
          layout="column"
          layout-align="start start"
          class="full-width px2-pc mb10-pc pb3-pc mb1-mobile px1-mobile bg-white"
        >
          <div
            layout="row"
            layout-align="start center"
            class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc"
          >{{$t('messages.filter')}}</div>
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            single-line
            flat
            v-model="filters.keywords"
            @keyup.enter="fetch(true)"
            hide-details
            class="full-width"
            :label="$t('filters.schools_hint')"
          ></v-text-field>

          <v-expansion-panel class="mt-3 exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div class="subheading">{{$t('messages.msg_types')}}</div>
              </template>
              <template v-for="t in types">
                <v-checkbox
                  hide-details
                  :label="t.text"
                  :value="t.value"
                  v-model="filters.type"
                  :key="`typefilter_${t.value}`"
                  @change="fetch(true)"
                  class="mt-0 pt-0 text-lowercase filter-cb"
                  :disabled="circle || isCircleShow"
                >
                  <template slot="label">
                    <div
                      layout="row"
                      layout-align="start center"
                    >
                      <v-icon
                        color="secondary"
                        class="mr-2"
                      >mdi-{{t.icon}}</v-icon>
                      <span>{{t.text}}</span>
                    </div>
                  </template>
                </v-checkbox>
                <div
                  v-if="t.value == Consts.CIRCLE"
                  :key="`typefilter_circles_${t.value}`"
                  layout="row"
                  class="pl-2"
                >
                  <div
                    layout="column"
                    class="ml-4"
                  >
                    <v-checkbox
                      v-for="c in $store.state.circles"
                      hide-details
                      :label="c.name"
                      :value="c.id"
                      v-model="filters.circle_id"
                      :key="`circlefilter_${c.id}`"
                      @change="fetch(true)"
                      class="mt-0 pt-0 body-1 filter-cb"
                      :disabled="circle || isCircleShow"
                    ></v-checkbox>
                  </div>
                </div>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div class="subheading">{{$t('_.date')}}</div>
              </template>
              <div
                layout="row"
                layout-align="start center"
                class="mb-1"
                flex
              >
                <div
                  layout="column"
                  layout-align="start start"
                  class="mr-2"
                  flex
                >
                  {{$t('_.from')}}
                  <v-menu
                    ref="menu1"
                    :close-on-content-click="false"
                    v-model="startDatepicker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    class="full-width"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="startFormatted"
                      :label="$t('_.date_format')"
                      flat
                      single-line
                      outline
                      append-outer-icon="mdi-calendar"
                      @blur="onStartBlur"
                      @keyup.enter="onStartBlur"
                      hide-details
                      class="date-field"
                    />
                    <v-date-picker
                      v-model="filters.start"
                      no-title
                      @input="startDatepicker = false; filters.start = parseDate(filters.start)"
                      @change="fetch(true)"
                      :first-day-of-week="1"
                      :locale="_locale"
                    />
                  </v-menu>
                </div>
                <div
                  layout="column"
                  layout-align="start start"
                  flex
                >
                  {{$t('_.to')}}
                  <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    v-model="endDatepicker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    class="full-width"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="endFormatted"
                      :label="$t('_.date_format')"
                      hide-details
                      class="date-field"
                      single-line
                      flat
                      outline
                      append-outer-icon="mdi-calendar"
                      @blur="onEndBlur"
                      @keyup.enter="onEndBlur"
                    />
                    <v-date-picker
                      v-model="filters.end"
                      no-title
                      @input="endDatepicker = false; filters.end = parseDate(filters.end)"
                      :first-day-of-week="1"
                      @change="fetch(true)"
                      :locale="_locale"
                    />
                  </v-menu>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div class="subheading">{{$t('filters.sender_sectors')}}</div>
              </template>
              <v-checkbox
                v-for="s in sectors"
                hide-details
                :label="s.text"
                :value="s.value"
                v-model="filters.sector"
                :key="`sectorfilter_${s.value}`"
                @change="fetch(true)"
                class="mt-0 pt-0 body-1 filter-cb"
              ></v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="exp-ctn">
            <v-expansion-panel-content class="exp-header">
              <template slot="header">
                <div class="subheading">{{$t('filters.sender_lvs')}}</div>
              </template>
              <v-checkbox
                v-for="l in levels"
                hide-details
                :label="l.text"
                :value="l.value"
                v-model="filters.level"
                :key="`levelfilter_${l.value}`"
                @change="fetch(true)"
                class="mt-0 pt-0 body-1 filter-cb"
              ></v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>
      <div
        v-if="photoDialog"
        class="photo-dialog active"
        @click="photoDialog = false"
        layout="row"
        layout-align="center center"
      >
        <span
          class="icontainer"
          layout="row"
          layout-align="center center"
        >
          <img :src="getImageData(displayedPhoto + '-1280px') || getImageData(displayedPhoto)" />
        </span>
      </div>
      <v-dialog
        v-if="messageDialog"
        v-model="messageDialog"
        max-width="900"
        z-index="202"
        :fullscreen="$vuetify.breakpoint. smAndDown"
      >
        <message
          :message="showingMessage"
          class="full-width"
          style="background: white"
          @edit="messageDialog = false; editMessage(showingMessage)"
          @removed="messageDialog = false"
          @deleted="messageDialog = false"
        ></message>
      </v-dialog>
      <v-dialog
        v-model="deleteDialog"
        max-width="400"
      >
        <v-card>
          <v-card-title class="title">{{$t('circles.delete_dialog')}}</v-card-title>
          <v-card-text>{{$t('circles.delete_info')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              flat="flat"
              @click="deleteDialog = false"
            >{{$t('_.cancel')}}</v-btn>
            <v-btn
              color="error"
              depressed
              @click="deleteDialog = false; deleteCircle()"
            >{{$t('_.delete')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </vue-pull-refresh>
</template>

<script>
import Messages from "@/api/messages"
import Circles from "@/api/circles"
import I18nMixin from "@/mixins/i18n"
import Consts from "@/consts"
import ImageMixin from "@/mixins/image"
import Avatar from "@/components/shared/Avatar.vue"
import Message from "@/components/shared/Message.vue"
import MessageForm from "@/components/shared/MessageForm.vue"
import Auth from "@/plugins/auth"
import FormDataMixin from "@/mixins/formdata"
import VEmojiPicker from "v-emoji-picker"
import BeatLoader from "vue-spinner/src/BeatLoader.vue"
import axios from "axios"
import moment from "moment"
import DateField from "@/components/shared/DateField"
import EventBus from "@/plugins/eventbus"
import VuePullRefresh from "vue-pull-refresh"

export default {
  mixins: [I18nMixin, ImageMixin, FormDataMixin],
  components: {
    Avatar,
    Message,
    MessageForm,
    VEmojiPicker,
    BeatLoader,
    DateField,
    VuePullRefresh
  },
  data () {
    return {
      filters: {
        keywords: null,
        is_enabled: null,
        sector: [],
        level: [],
        type: [],
        circle_id: [],
        rowsPerPage: 10,
        descending: 1,
        sortBy: "published_at",
        page: 1,
        start: null,
        end: null
      },
      messages: [],
      schools: [],
      rds: [],
      regions: [],
      displayFilters: false,
      imgs: {},
      imgsLoad: {},
      isEditingMessage: false,
      isEditingEvent: false,
      startDatepicker: false,
      endDatepicker: false,
      startDatepicker2: false,
      endDatepicker2: false,
      editingMessage: {
        type: Consts.CIRCLE,
        body: "",
        levels_ids: [],
        sectors_ids: [],
        schools_ids: [],
        regional_directorates_ids: [],
        regions_ids: [],
        cities_ids: [],
        circles_ids: [],
        date_start: null
      },
      loading: true,
      noMoreData: false,
      bottom: false,
      circle: false,
      photosLoaded: false,
      docsLoaded: false,
      photos: [],
      docs: [],
      limit: null,
      yPosition: 0,
      hasNewMessage: false,
      pullConfig: {
        errorLabel: "",
        startLabel: "",
        readyLabel: "",
        loadingLabel: "",
        pullDownHeight: 0
      },
      displayedPhoto: null,
      photoDialog: false,
      resetCounter: false,
      messageDialog: false,
      showingMessage: {
        type: Consts.CIRCLE,
        body: "",
        levels_ids: [],
        sectors_ids: [],
        schools_ids: [],
        regional_directorates_ids: [],
        regions_ids: [],
        cities_ids: [],
        circles_ids: [],
        date_start: null
      },
      circle_info: true,
      displayedCircle: null,
      deleteDialog: false,
      Consts,
      specificCircle: false
    }
  },
  created () {
    if (this.$route.query && this.$route.query.message_id) {
      Messages.get(this.$route.query.message_id).then(res => {
        this.showingMessage = res.data
        this.messageDialog = true
      })
    }

    if (this.$route.name == "my-circle") {
      this.circle = true
      this.fetchNbCircle()
      EventBus.$on("new-circle", () => (this.hasNewMessage = true))
    } else if (this.$route.name == "my-wall") {
      this.fetchNbWall()
      EventBus.$on("new-wall", () => (this.hasNewMessage = true))
    } else {
      this.fetchCircle()
    }

    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible()
      this.yPosition = window.pageYOffset
    })

    this.circle_info = Auth.user.circle_info
  },
  beforeRouteUpdate (to, from, next) {
    if (to.name === 'circles-show' && from.name === 'circles-show') {
      this.photosLoaded = false
      this.docsLoaded = false
      this.fetchCircle(to.params.id)
    }

    next()
  },
  destroyed () {
    EventBus.$off("new-circle")
    EventBus.$off("new-wall")
  },
  watch: {
    bottom (bottom) {
      if (!this.noMoreData && !this.loading && bottom) {
        this.filters.page++
        this.fetch()
      }
    },
    "$route.name" (val) {
      if (
        val == "my-wall" ||
        val == "my-circle" ||
        val.indexOf("circles-show") === 0
      ) {
        this.photosLoaded = false
        this.docsLoaded = false

        if (val == "my-wall") {
          this.circle = false
          this.fetchNbWall()
          EventBus.$on("new-wall", () => (this.hasNewMessage = true))
          EventBus.$off("new-circle")
        } else if (val == "my-circle") {
          this.circle = true
          this.fetchNbCircle()
          EventBus.$on("new-circle", () => (this.hasNewMessage = true))
          EventBus.$off("new-wall")
        } else {
          this.circle = false
          this.fetchCircle()
        }
      }
    }
  },
  methods: {
    onMessageCancel () {
      this.isEditingMessage = false
      this.resetMessage()
    },
    onEventCancel () {
      this.isEditingEvent = false
      this.resetMessage()
    },
    onStartBlur (val) {
      let date = this.parseDate(val.target.value)
      if (this.filters.start != date) {
        this.filters.start = date
        this.fetch(true)
      }
    },
    onEndBlur (val) {
      let date = this.parseDate(val.target.value)
      if (this.filters.end != date) {
        this.filters.end = date
        this.fetch(true)
      }
    },
    fetch (reset = false) {
      this.loading = true
      if (reset) {
        //On applique un nouveau filtre donc on repart à la 1e page avec de nouveaux messages
        this.messages = []
        this.filters.page = 1
        this.noMoreData = false
      }

      Messages.getList(this.filters).then(res => {
        this.loading = false

        if (res.data && res.data.length) {
          for (let i = 0; i < res.data.length; i++) {
            this.messages.push(res.data[i])
          }
        } else {
          this.noMoreData = true
        }

        if (this.resetCounter) {
          if (this.circle) {
            EventBus.$emit("circle-fetch")
          }
          else if (this.isCircleShow) {
            this.$store.commit("LOAD_CIRCLES", true)
          }
          else {
            EventBus.$emit("wall-fetch")
          }
          this.resetCounter = false
        }

        //Les requêtes ne sont effectuées qu'après et seulement si les données ne sont pas déjà chargées
        this.fetchPhotos()
        this.fetchDocs()
        this.$store.commit("LOAD_LOGO")

        if (!this.noMoreData && !this.loading && this.bottomVisible()) {
          this.filters.page++
          this.fetch()
        }
      })
    },
    fetchPhotos () {
      if (!this.photosLoaded) {
        Messages.getPhotos(this.filters).then(res => {
          this.photos = res.data

          //Charge les preview des photos ou directement les photos
          for (let i = 0; i < this.photos.length; i++) {
            this.getImage(
              "/assets/messageMediasPreview/" + this.photos[i].id,
              this.photos[i].id + "-preview"
            ).then(
              () => { },
              () => {
                this.getImage(
                  "/assets/messageMedias/" + this.photos[i].id,
                  this.photos[i].id
                )
              }
            )
          }

          this.photosLoaded = true
        })
      }
    },
    fetchDocs () {
      if (!this.docsLoaded) {
        Messages.getDocs(this.filters).then(res => {
          this.docs = res.data
          this.docsLoaded = true
        })
      }
    },
    fetchCircle (id = null) {
      Circles.get(id ? id : this.$route.params.id).then(res => {
        this.displayedCircle = res.data

        for (let i = 0; i < this.$store.state.circles.length; i++) {
          if (this.$store.state.circles[i].id === this.displayedCircle.id) {
            this.limit = this.$store.state.circles[i].nb_unread
            break
          }
        }

        this.resetFilters()
      }, () => {
        this.$router.push({ name: 'my-wall' })
      })
    },
    fetchNbCircle () {
      Messages.getUnread(1).then(res => {
        this.limit = res.data
        this.resetFilters()
      })
    },
    fetchNbWall () {
      Messages.getUnread(0).then(res => {
        this.limit = res.data
        this.resetFilters()
      })
    },
    loadNewMessages () {
      this.photosLoaded = false
      this.docsLoaded = false
      this.resetCounter = true

      if (this.circle) {
        this.fetchNbCircle()
      } else {
        this.fetchNbWall()
      }

      this.hasNewMessage = false
      let a = document.createElement("a")
      document.body.appendChild(a)
      a.style = "display: none"
      a.href = "#message-form"
      a.click()
    },
    onPhotoClick (p) {
      this.getImage(
        "/assets/messageMedias1280px/" + p.id,
        p.id + "-1280px"
      ).then(
        () => { },
        () => {
          this.getImage("/assets/messageMedias/" + p.id, p.id)
        }
      )

      this.displayedPhoto = p.id
      this.photoDialog = true
    },
    onRefresh () {
      if (this.yPosition == 0) {
        this.photosLoaded = false
        this.docsLoaded = false

        if (this.circle) {
          this.fetchNbCircle()
        } else {
          this.fetchNbWall()
        }

        this.hasNewMessage = false
      }

      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve()
        }, 1)
      })
    },
    resetFilters () {
      this.filters = {
        keywords: null,
        is_enabled: null,
        sector: [],
        level: [],
        rowsPerPage: 10,
        descending: 1,
        sortBy: 'published_at',
        page: 1,
        start: null,
        end: null,
        type: (this.circle || this.isCircleShow) ? [Consts.CIRCLE] : [],
        circle_id: this.isCircleShow ? [this.displayedCircle.id] : []
      }
      this.fetch(true)
    },
    resetMessage () {
      this.$refs.messageForm.$refs.form.reset()
      this.defaultMessage()
    },
    defaultMessage () {
      this.editingMessage = Object.assign(
        {},
        {
          type: Consts.CIRCLE,
          body: "",
          levels_ids: [],
          sectors_ids: [],
          schools_ids: [],
          regional_directorates_ids: [],
          regions_ids: [],
          cities_ids: [],
          date_start: null
        }
      )
    },
    newMessage () {
      this.isEditingEvent = false
      this.isEditingMessage = true
      this.defaultMessage()
      if (this.circle) {
        this.editingMessage.circles_ids = [null]
      } else if (this.isCircleShow) {
        this.editingMessage.circles_ids = [this.displayedCircle.id]
      }
    },
    newEvent () {
      this.isEditingMessage = false
      this.isEditingEvent = true
      this.defaultMessage()
      this.editingMessage.type = Consts.EVENT
    },
    save (data) {
      if (!this.$refs.messageForm.$refs.form.validate()) {
        return
      }

      if (
        this.isEditingEvent &&
        (!this.editingMessage.date_start ||
          !moment(this.editingMessage.date_start).isValid())
      ) {
        this.$snotify.error(this.$t("messages.date_err"))
        return
      }

      this.loading = true

      // Convert the data to FormData for proper file upload
      let formData = new FormData()
      let o = Object.assign(
        {},
        this.editingMessage,
        { deleted_medias: data.deletedMedias },
        { deleted_docs: data.deletedDocs }
      )
      this._convertObjectToFormData(formData, o)

      if (data.banner && data.banner != {} && data.banner instanceof Blob) {
        formData.append("banner", data.banner, data.banner.name)
      }

      for (let i = 0; i < data.medias.length; i++) {
        if (!data.medias[i].id) {
          formData.append(
            "medias[" + i + "]",
            data.medias[i],
            data.medias[i].name
          )
        }
      }

      for (let i = 0; i < data.documents.length; i++) {
        if (!data.documents[i].id) {
          formData.append(
            "documents[" + i + "]",
            data.documents[i],
            data.documents[i].name
          )
        }
      }

      if (!this.editingMessage.id) {
        Messages.create(formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.$snotify.success(this.$t("messages.created"))
            this.photosLoaded = false
            this.docsLoaded = false
            this.resetFilters()
          },
          () => {
            this.loading = false
          }
        )
      } else {
        Messages.updateAsForm(this.editingMessage.id, formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.$snotify.success(this.$t("messages.edited"))
            this.photosLoaded = false
            this.docsLoaded = false
            this.resetFilters()
          },
          () => {
            this.loading = false
          }
        )
      }
    },
    onMessageUpdate () {
      this.photosLoaded = false
      this.docsLoaded = false
      this.resetFilters()
    },
    onDelete (i) {
      this.messages.splice(i, 1)
    },
    editMessage (m) {
      if (m.type == Consts.SURVEY) {
        this.$router.push({
          name: "surveys-edit",
          params: { id: m.survey_id }
        })
      } else if (m.type == Consts.EVENT) {
        this.defaultMessage()
        this.editingMessage = JSON.parse(JSON.stringify(m))
        this.isEditingEvent = true
        let a = document.createElement("a")
        document.body.appendChild(a)
        a.style = "display: none"
        a.href = "#message-form"
        a.click()
      } else {
        this.defaultMessage()
        this.editingMessage = JSON.parse(JSON.stringify(m))

        this.isEditingMessage = true
        let a = document.createElement("a")
        document.body.appendChild(a)
        a.style = "display: none"
        a.href = "#message-form"
        a.click()

        this.editingMessage.levels_ids = []
        this.editingMessage.sectors_ids = []
        this.editingMessage.regional_directorates_ids = []
        this.editingMessage.regions_ids = []
        this.editingMessage.cities_ids = []
        this.editingMessage.schools_ids = []
        this.editingMessage.circles_ids = []

        for (
          let i = 0;
          i < this.editingMessage.regional_directorates.length;
          i++
        ) {
          this.editingMessage.regional_directorates_ids.push(
            this.editingMessage.regional_directorates[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.regions.length; i++) {
          this.editingMessage.regions_ids.push(
            this.editingMessage.regions[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.schools.length; i++) {
          this.editingMessage.schools_ids.push(
            this.editingMessage.schools[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.levels.length; i++) {
          this.editingMessage.levels_ids.push(
            this.editingMessage.levels[i].level
          )
        }

        for (let i = 0; i < this.editingMessage.sectors.length; i++) {
          this.editingMessage.sectors_ids.push(
            this.editingMessage.sectors[i].sector
          )
        }

        for (let i = 0; i < this.editingMessage.cities.length; i++) {
          this.editingMessage.cities_ids.push(this.editingMessage.cities[i].id)
        }
      }
    },
    parseDate (date) {
      if (!date) return null

      if (date.indexOf("-") >= 0) {
        return date
      }

      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")
    },
    bottomVisible () {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
    downloadDoc (doc) {
      const doc_id = doc.id
      axios
        .get(`/assets/messageDocs/${doc_id}`, { responseType: "blob" })
        .then(res => {
          this.downloadFile(res.data, doc.document.name)
        })
    },
    hideCircleInfo () {
      this.circle_info = false
      this.$store.commit("SET_CIRCLE_INFO")
    },
    deleteCircle () {
      Circles.delete(this.displayedCircle.id).then(() => {
        this.$store.commit("LOAD_CIRCLES", true)
        this.$snotify.success(this.$t("circles.deleted"))
        this.$router.push({ name: "my-wall" })
      })
    },
    joinCircle () {
      Circles.join(this.displayedCircle.id).then(() => {
        this.$snotify.success(this.$t("circles.joined"))
        this.displayedCircle.users_ids.push(Auth.user.id)
        this.displayedCircle.users.push(Auth.user)
        this.$store.commit("LOAD_CIRCLES", true)
      })
    },
    leaveCircle () {
      Circles.leave(this.displayedCircle.id).then(() => {
        this.$snotify.success(this.$t("circles.left"))
        const idx = this.displayedCircle.users_ids.indexOf(Auth.user.id)
        if (idx > -1) {
          this.displayedCircle.users_ids.splice(idx, 1)
          this.displayedCircle.users.splice(idx, 1)
        }
        this.$store.commit("LOAD_CIRCLES", true)
        if (this.displayedCircle.is_private) {
          this.$router.push({ name: 'my-wall' })
        }
      })
    }
  },
  computed: {
    sectors () {
      return [
        { value: Consts.PRIMARY, text: this.$t("schools.sector_prim") },
        { value: Consts.SECONDARY, text: this.$t("schools.sector_sec") },
        { value: Consts.COMPETENCECENTRE, text: this.$t("schools.sector_comp") }
      ]
    },
    levels () {
      return [
        { value: Consts.MINISTRY, text: this.$t("users.lv_min") },
        { value: Consts.NATIONAL, text: this.$t("users.lv_nat") },
        { value: Consts.SECTORAL, text: this.$t("users.lv_sec") },
        { value: Consts.LOCAL, text: this.$t("users.lv_loc") }
      ]
    },
    types () {
      return [
        {
          value: Consts.EVENT,
          text: this.$t("messages.evts"),
          icon: "calendar"
        },
        {
          value: Consts.SURVEY,
          text: this.$t("messages.surveys"),
          icon: "clipboard-text"
        },
        {
          value: Consts.CIRCLE,
          text: this.$t("messages.int_msgs"),
          icon: "set-none"
        },
        {
          value: Consts.PLATFORM,
          text: this.$t("messages.public_msgs"),
          icon: "send"
        },
        {
          value: Consts.TOPDOWN,
          text: this.$t("messages.topdowns"),
          icon: "arrow-expand-down"
        },
        {
          value: Consts.BOTTOMUP,
          text: this.$t("messages.bottomups"),
          icon: "arrow-expand-up"
        },
        {
          value: Consts.HORIZONTAL,
          text: this.$t("messages.horizontal"),
          icon: "arrow-expand-horizontal"
        }
      ]
    },
    startFormatted: {
      get () {
        return this.filters.start
          ? this.formatDateI18n(this.filters.start)
          : null
      },
      set (x) {
        this.$emit("input", x)
      }
    },
    endFormatted: {
      get () {
        return this.filters.end ? this.formatDateI18n(this.filters.end) : null
      },
      set (x) {
        this.$emit("input", x)
      }
    },
    isMinistry () {
      if (Auth.user.level == Consts.MINISTRY || Auth.user.is_admin) {
        return true
      }
      return false
    },
    isNational () {
      if (Auth.user.level == Consts.NATIONAL) {
        return true
      }
      return false
    },
    isSectoral () {
      if (Auth.user.level == Consts.SECTORAL) {
        return true
      }
      return false
    },
    isLocal () {
      if (Auth.user.level == Consts.LOCAL) {
        return true
      }
      return false
    },
    circleInfo () {
      if (this.isMinistry) {
        return this.$t("messages.circle_info_men")
      } else if (this.isNational) {
        return this.$t("messages.circle_info_nat")
      } else if (this.isSectoral) {
        return this.$t("messages.circle_info_sec")
      } else if (this.isLocal) {
        return this.$t("messages.circle_info_loc")
      }
    },
    isCircleShow () {
      if (this.$route.name === "circles-show") {
        return true
      }

      return false
    },
    isOwnCircle () {
      if (
        this.isCircleShow &&
        this.displayedCircle &&
        this.displayedCircle.creator_id === Auth.user.id
      ) {
        return true
      }

      return false
    },
    circleDeletable () {
      if (this.isOwnCircle) {
        return true
      }
      if (
        this.isMinistry &&
        this.isCircleShow &&
        this.displayedCircle &&
        !this.displayedCircle.is_private
      ) {
        return true
      }

      return false
    },
    canJoin () {
      if (this.isOwnCircle) {
        return false
      }
      if (!this.displayedCircle) {
        return false
      }
      if (this.displayedCircle.is_private) {
        return false
      }
      const idx = this.displayedCircle.users_ids.indexOf(Auth.user.id)
      if (idx > -1) {
        return false
      }

      return true
    },
    canLeave () {
      if (this.isOwnCircle) {
        return false
      }
      if (!this.displayedCircle) {
        return false
      }
      const idx = this.displayedCircle.users_ids.indexOf(Auth.user.id)
      if (idx <= -1) {
        return false
      }

      return true
    }
  }
}
</script>
<style>
.exp-header > .v-expansion-panel__header > div {
  margin-left: 5px;
  font-weight: bold;
}
.exp-header
  > .v-expansion-panel__header
  > .v-expansion-panel__header__icon
  > .v-icon {
  position: absolute;
  left: 0;
  margin-left: 0px;
  margin-right: 5px;
  top: 12px;
  font-weight: bold;
}
.exp-ctn {
  box-shadow: none;
}

.exp-header > .v-expansion-panel__header > div.subheading {
  font-size: 16px !important;
}

.date-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > .v-label {
  font-size: 14px;
  line-height: 18px;
  top: 14px;
}

.date-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  font-size: 14px;
}

.date-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  margin-top: 7px;
}

.date-field.v-text-field > .v-input__append-outer {
  margin-top: 12px;
}

.date-field > .v-input__control > .v-input__slot {
  min-height: 46px;
}
.pull-down-header {
  max-height: 60px;
  background: unset;
}
.photo-dialog {
  position: relative;
  cursor: pointer;
  margin: 12px;
}

.photo-dialog.active {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  margin: 0;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.photo-dialog > .icontainer {
  text-align: center;
}
.photo-dialog.active > .icontainer {
  width: 100%;
  height: 100%;
}
.photo-dialog.active img {
  max-width: 100%;
  max-height: 100%;
  z-index: 8;
  margin: auto;
}
.photo-dialog > div {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 8px;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.photo-dialog > div > div {
  pointer-events: none;
}
.photo-dialog:hover > div {
  opacity: 1;
}
.photo-dialog.active > div {
  opacity: 1;
  top: 0;
  bottom: unset;
}

.filter-cb > .v-input__control > .v-input__slot > .v-label {
  font-size: 14px;
  color: black;
}
</style>
<style scoped>
@media screen and (min-width: 960px) {
  .messages-col {
    margin-right: 40px;
    margin-left: 30px;
  }
}
.active-form {
  font-weight: bold;
  color: #2e3b7f;
}
</style>